"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function randomKey(prefix = '') {
    let key = '';
    if (prefix)
        key += prefix + '-';
    key += Math.random().toString(36).substr(2, 11);
    return key;
}
exports.default = randomKey;
